// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"210":"vendor.footer-component","277":"vendor.axios","625":"vendor.react-datepicker","968":"vendor.dayjs","979":"vendor.web-vitals"}[chunkId] + "." + {"210":"4f284550","277":"62e5f350","625":"cb4c48ba","968":"598b2e69","979":"9b9cd24f"}[chunkId] + ".chunk.js";
};